module.exports = __webpack_public_path__ + "img/countdown_bg.371d1416.png";